import dialogForm from './src/index.js'

export default dialogForm
